import { CustomerDto } from '@maia/shared';
import { BaseCardProps, CardBase } from './base';
import { FeaturedIcon, Typography } from '../../../ui';
import { IconUserCircle } from '@maia/icons';

interface CustomerCardProps extends BaseCardProps {
  readonly customer: CustomerDto;
}

export function CustomerCard(props: CustomerCardProps) {
  const { customer, ...rest } = props;

  return (
    <CardBase {...rest}>
      <Typography
        variant="body-xs"
        weight="medium"
        className="text-primaryMain"
      >
        {customer.reference}
      </Typography>
      <div className="flex items-center gap-x-14 flex-grow">
        <FeaturedIcon icon={<IconUserCircle />} variant="light-circle" />
        <Typography
          variant="body-xs"
          weight="medium"
          className="text-primaryMain"
        >
          {customer.consumer.fullName}
        </Typography>
      </div>
    </CardBase>
  );
}
